import React from 'react';
import { Text, BlockStack, InlineStack, Button } from '@shopify/polaris';
import type { ButtonProps } from '@shopify/polaris';

interface PricingCardProps {
  title: string;
  featuredText?: string;
  description?: string;
  features: string[];
  price: string;
  frequency?: string;
  button: {
    content: string;
    props?: ButtonProps;
  };
  withoutCard?: boolean;
}

export const PricingCard: React.FC<PricingCardProps> = ({
  title,
  featuredText,
  description,
  features,
  price,
  frequency,
  button,
  withoutCard = false,
}) => {
  const content = (
    <div
      className={`genseo-pricing-card ${featuredText ? 'genseo-pricing-card--featured' : ''} ${withoutCard ? 'genseo-pricing-card--plain' : ''}`}
      style={{ position: 'relative' }}
    >
      {featuredText ? (
        <div className="genseo-pricing-card__badge">
          <span className="genseo-pricing-card__badge-pill">{featuredText}</span>
        </div>
      ) : null}
      <div className="genseo-pricing-card__content">
        <BlockStack gap="200">
          <Text variant="headingMd" as="h3">
            {title}
          </Text>
          {description ? (
            <Text as="p" tone="subdued">
              {description}
            </Text>
          ) : null}
        </BlockStack>

        <InlineStack gap="100" blockAlign="end">
          <Text variant="headingLg" as="p">
            {price}
          </Text>
          {frequency ? (
            <Text as="span" tone="subdued">
              /{frequency}
            </Text>
          ) : null}
        </InlineStack>

        <BlockStack gap="100">
          {features.map((feature) => (
            <div className="pricing-feature-item" key={feature}>
              <svg
                className="pricing-feature-icon"
                viewBox="0 0 20 20"
                width="20"
                height="20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.5 14.5L4 10l1.5-1.5L8.5 11.5l6-6L16 7l-7.5 7.5z"
                  fill="var(--p-color-icon-success, #008060)"
                />
              </svg>
              <Text as="span" tone="subdued" variant="bodySm">
                {feature}
              </Text>
            </div>
          ))}
        </BlockStack>

        <div className="genseo-pricing-card__action">
          <Button fullWidth variant="primary" {...button.props}>
            {button.content}
          </Button>
        </div>
      </div>
    </div>
  );

  return content;
};
